export default "__VITE_ASSET__urwKihHW__"